export const BRAND = {
  name: "LionPerformance",
  logo: "https://customer-assets.emergentagent.com/job_b55ddb44-8b6b-403e-bd6a-a758d1483346/artifacts/zue0p0zy_7C5DB359-F459-4A34-AE1A-3FC6C3998E69.png",
  heroImage:
    "https://images.unsplash.com/photo-1591117207239-788bf8de6c3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  expertPortrait:
    "https://customer-assets.emergentagent.com/job_elite-coaching-32/artifacts/lazqi73a_D417CDAE-65BF-4B9B-A19B-9834C17A874C.png",
  onlineImage:
    "https://images.unsplash.com/photo-1510519138101-570d1dca3d66?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  premiumImage:
    "https://images.unsplash.com/photo-1518611012118-696072aa579a?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};

export const NAV_LINKS = [
  { id: "warum", labelKey: "nav.why" },
  { id: "coach", labelKey: "nav.coach" },
  { id: "leistungen", labelKey: "nav.services" },
  { id: "ablauf", labelKey: "nav.process" },
  { id: "faq", labelKey: "nav.faq" },
  { id: "kontakt", labelKey: "nav.contact" },
];
